// Admin API Endpoints
export const ADMIN_ENDPOINTS = {
  // Organizations
  ORGANIZATIONS: '/api/admin/organizations',
  ORGANIZATION_BY_ID: (id: string) => `/api/admin/organizations/${id}`,
  
  // Users
  USERS: '/api/admin/users',
  USER_BY_ID: (id: string | number) => `/api/admin/users/${id}`,
  USER_PASSWORD: (id: string | number) => `/api/admin/users/${id}/password`,
  USER_STATUS: (id: string | number) => `/api/admin/users/${id}/status`,
  USER_ORGANIZATIONS: (id: string | number) => `/api/admin/users/${id}/organizations`,
  
  // Integration Types (for dropdowns)
  INTEGRATION_TYPES: '/api/admin/integration-types',
  INTEGRATION_TYPE_BY_ID: (id: string | number) => `/api/admin/integration-types/${id}`,

  // Organization Integrations
  ORG_INTEGRATIONS: (orgId: string) => `/api/admin/organizations/${orgId}/integrations`,
  ORG_INTEGRATION_BY_ID: (orgId: string, integrationId: string) =>
    `/api/admin/organizations/${orgId}/integrations/${integrationId}`,
  
  // Organization Members
  ORG_MEMBERS: (orgId: string) => `/api/admin/organizations/${orgId}/members`,
  ORG_MEMBER_BY_ID: (orgId: string, userId: string) => 
    `/api/admin/organizations/${orgId}/members/${userId}`,
  ORG_MEMBER_DEFAULT: (orgId: string, userId: string) => 
    `/api/admin/organizations/${orgId}/members/${userId}/default`,
  ORG_MEMBER_ROLE: (orgId: string, userId: string) => 
    `/api/admin/organizations/${orgId}/members/${userId}/role`,
  
  // Organization Metadata & Settings
  ORG_METADATA: (orgId: string) => `/api/admin/organizations/${orgId}/metadata`,
  ORG_SETTINGS: (orgId: string) => `/api/admin/organizations/${orgId}/settings`,
  
  // Dashboard Stats
  DASHBOARD_STATS: '/api/admin/dashboard/stats',

  // RBAC (Approach 3 — global role → module mapping)
  RBAC_ROLES: '/api/admin/rbac/roles',
  RBAC_ROLE_BY_KEY: (roleKey: string) => `/api/admin/rbac/roles/${encodeURIComponent(roleKey)}`,
  RBAC_FEATURES: '/api/admin/rbac/features',
  RBAC_FEATURE_BY_KEY: (featureKey: string) =>
    `/api/admin/rbac/features/${encodeURIComponent(featureKey)}`,
  RBAC_ROLE_FEATURES: (roleKey: string) =>
    `/api/admin/rbac/roles/${encodeURIComponent(roleKey)}/features`,

  // SOP Synthesizer videos
  SOP_VIDEOS: '/api/admin/sop-videos',

  // Model Compare (platform admin only)
  MODEL_COMPARE_CATALOG: '/api/admin/model-compare/catalog',
  MODEL_COMPARE_RUN: '/api/admin/model-compare/run',
  MODEL_COMPARE_RUNS: '/api/admin/model-compare/runs',

  // AI Usage (every model call, platform admin only)
  AI_CALLS_SUMMARY: '/api/admin/ai-calls/summary',
  AI_CALLS: '/api/admin/ai-calls',
  SOP_VIDEO_UPLOAD_INIT: '/api/admin/sop-videos/uploads/init',
  SOP_VIDEO_UPLOAD_COMPLETE: '/api/admin/sop-videos/uploads/complete',
  SOP_VIDEO_BY_ID: (id: string) => `/api/admin/sop-videos/${id}`,
  SOP_VIDEO_RESUME: (id: string) => `/api/admin/sop-videos/${id}/uploads/resume`,
  SOP_VIDEO_PROCESS: (id: string) => `/api/admin/sop-videos/${id}/process`,
  SOP_VIDEO_VALIDATE: (id: string) => `/api/admin/sop-videos/${id}/validate`,

  // Audit log (platform admin, read-only)
  AUDIT_EVENTS: '/api/admin/audit-events',
  AUDIT_EVENT_BY_ID: (id: string) => `/api/admin/audit-events/${encodeURIComponent(id)}`,
  // Audit log (org admin, current org only)
  ORG_AUDIT_EVENTS: '/api/org-admin/audit-events',
  ORG_AUDIT_EVENT_BY_ID: (id: string) => `/api/org-admin/audit-events/${encodeURIComponent(id)}`,

  // Platform Settings (platform admin only)
  PLATFORM_FEATURE_FLAGS: '/api/admin/platform-settings/feature-flags',
  WIDGET_DEMO_DATA: '/api/admin/widget-demo-data',
  WIDGET_DEMO_DATA_GENERATE: '/api/admin/widget-demo-data/generate',
} as const;
